import types from '../constants/types'

export const commitMutation = {
  [types.COMMIT_REQUEST] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = true
    state[action.request]['didInvalidate'] = false
  },
  [types.COMMIT_SUCCESS] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = false
    state[action.request]['data'] = action.data.data || action.data.info
    state[action.request]['lastUpdated'] = (new Date()).getTime()
  },
  [types.COMMIT_FAILURE] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = true
  },
  [types.COMMIT_INIT] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = false
  }
}
